import React from "react";
import request from 'superagent';
import {USER_COMMUNICATION_BOOK} from "../constants/Url";
// import TagManager from 'react-gtm-module';
// import {getTagManagerArgs} from './Util';

export class LscContent extends React.Component {
  handleClickSwitchPage(page) {
    if (this.props.toggleResult) {
      this.props.toggleResultMethod();
    }
    this.props.switchPageMethod(page);
  }

  constructor(props) {
    super(props);

    this.state = {
      tab: "obesity",
    };

    this._handleClick = this._handleClick.bind(this);
  }

  _handleClick(event) {
    const element = event.currentTarget;

    const tabState = element.getAttribute("aria-controls");

    this.setState({
      tab: tabState
    });
  }

  render() {
    // TagManager.initialize(getTagManagerArgs('/lsc_content'));

    const { nickname, lsc_status, lsc_result } = this.props;

    return (
      <div className="wrap lscwrap">
        <div className="lsc_toplogo">
          <div>{nickname}さんの</div>
          <div className="lsc_toplogo_l">通信簿</div>
        </div>
        <p>
          検査結果閲覧前にご回答いただいたライフスタイルアンケートから、"現在"のあなたのライフスタイルをチェックさせていただきました。
          <br/>
          その名も「通信簿」です。普段の生活環境を見直すことで、将来かかり得る病気の未病対策や健康な毎日を過ごすためのきっかけになればと思い、ご用意いたしました。
          体に及ぼす影響は、遺伝が30％、環境要因が70％といわれています。ライフスタイルの改善にお役立てください。
        </p>
        <br/>
        <p className="lsc_toplogo_m center">あなたのライフスタイル</p>

        {(lsc_status == "ok" )&&
        <div className="app_tab lsc_cards_tab">
          <ul role="tablist">

            {lsc_result.map(r =>
              <li key = {r.handle} role="presentation">
                <button
                  role="tab"
                  aria-controls={r.handle}
                  aria-selected={this.state.tab === r.handle}
                  onClick={this._handleClick}
                >
                  <div>{r.name}</div>
                  <img src={require("../images/lsc/" + r.handle + ".svg")} />
                </button>
              </li>
              )}

          </ul>
        </div>
        }
        

　　　　　{ (lsc_status == "ok") &&
          lsc_result.map(r =>
          <div
            key = {r.handle}
            role="tabpanel"
            id = {r.handle}
            aria-hidden={this.state.tab !== r.handle}
          >
            <h2>{r.name}に関するアドバイス</h2>
            <table className="lsc_table">
              <tbody>
                <tr>
                  <th scope="col">あなたのライフスタイル</th>
                  <th scope="col">評価</th>
                  <th scope="col">アドバイス</th>
                </tr>
                {r.articles.map(a =>
                <tr key = {a.question} className="lsc_table_sect">
                  <td className="lsc_advice_item">
                    <p className="lsc_advice_item_title">{a.question}</p>
                    <p>{a.answer}</p>
                  </td>
                  <td className="lsc_advice_comment">
                    {a.judgment}
                  </td>
                  <td className="lsc_advice">
                    {a.comment}
                  </td>
                </tr>
                )}
              </tbody>
            </table>
          </div>
          )
          }  
           
        </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/LscContent.js